<template>
  <el-form-item :label="i18nt('designer.setting.showClose')">
    <el-switch v-model="optionModel.showClose"></el-switch>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../../utils/i18n"

  export default {
    name: "showClose-editor",
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// showClose-editor.vue?e3fd11d8